var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWaterbottle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3763 4.74967H16.6263C16.1891 4.74967 15.8346 4.39523 15.8346 3.95801V3.16634C15.8346 2.29189 16.5435 1.58301 17.418 1.58301H20.5846C21.4591 1.58301 22.168 2.29189 22.168 3.16634V3.95801C22.168 4.39523 21.8135 4.74967 21.3763 4.74967ZM25.3346 15.833V11.083C25.3346 9.33411 23.9169 7.91634 22.168 7.91634H15.8346C14.0857 7.91634 12.668 9.33411 12.668 11.083V15.833C12.668 16.7075 13.3769 17.4163 14.2513 17.4163V20.488C13.3769 20.488 12.668 21.1969 12.668 22.0713V34.833C12.668 35.7075 13.3769 36.4163 14.2513 36.4163H23.7513C24.6258 36.4163 25.3346 35.7075 25.3346 34.833V22.0713C25.3346 21.1969 24.6258 20.488 23.7513 20.488V17.4163C24.6258 17.4163 25.3346 16.7075 25.3346 15.833ZM21.3763 30.083H16.6263C16.1891 30.083 15.8346 29.7286 15.8346 29.2913V24.5413C15.8346 24.1041 16.1891 23.7497 16.6263 23.7497H21.3763C21.8135 23.7497 22.168 24.1041 22.168 24.5413V29.2913C22.168 29.7286 21.8135 30.083 21.3763 30.083Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaterbottle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/waterbottle.b086d256.svg";
export { ForwardRef as ReactComponent };